import { DropdownItemType } from '@/_redesign/shared/ui/Dropdown/DropdownItem/DropdownItem.vue';
import { getFuseDropdownSearcher } from '@/components/formkit/inputs/SearchDropdown/DropdownSearcher';
import {
  TCountry,
} from '@/constants/countries';

export function getCountrySearcher(withPrefix = false) {
  const keys = [
    { name: 'name', weight: 3 },
    { name: 'phoneCode', weight: 3 },
    { name: 'keyWords', weight: 2 },
    'shortName',
    'code',
  ];
  const prefix = withPrefix ? 'searchData.' : '';

  const prefixedKeys = keys.map((key) => (typeof key === 'string'
    ? `${prefix}${key}`
    : { ...key, name: `${prefix}${key.name}` }));

  return getFuseDropdownSearcher<DropdownItemType | TCountry>({
    threshold: 0.1,
    ignoreLocation: true,
    keys: prefixedKeys,
  });
}
